/**
 * @file
 * A collection of map markers used by BasstrakkMap component.
 */
import * as React from 'react';
import { createCustomIcon } from '../processing';

// Types
import { IMarker, LayerType } from '../types';

// Components
import { PopupMarker } from './BasstrakkMapPopupMarker';

interface IProps {
  markerData: IMarker[];
  layer: LayerType;
}

class MapMarkers extends React.PureComponent<IProps> {
  public render() {
    const { markerData, layer } = this.props;
    const markers = markerData.map(({ markerId, rank, ...props }) => (
      <PopupMarker
        markerId={markerId}
        icon={createCustomIcon(layer, rank)}
        key={markerId}
        rank={rank}
        {...props}
        data-testid="map-marker"
      />
    ));

    return <div data-testid="map-markers">{markers}</div>;
  }
}

export default MapMarkers;
